

import { useEffect, useState } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { WorkNameDDLAPI, WorkSubTypeDDLAPI } from '../../Redux/DDLSlice'
import { AstricSign } from '../../Helper/AstricSign'

export const DummyDDL = (props) => {
    const { Name} = props


    return (
        <div className="form-group">
            <label for="" className=""><b>{Name}</b></label>

            <Select
                isClearable={false}
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable={false}
                maxMenuHeight={115}
                // value={{ value: WorkName.ID, label: WorkName.Label }}
                // onChange={(e) => {
                //     e ?
                //         setWorkName({ ...WorkName, ID: e.value, Label: e.label })
                //         :
                //         setWorkName({ ...WorkName, ID: 0, Label: "Select..." })

                // }}
                // options={WorkName.DDL}
            />
        </div>
    )
}